module.exports = __webpack_public_path__ + "img/9_68.5451322a.png";